var _path, _rect, _path2, _rect2, _path3, _path4, _path5, _path6, _path7, _path8, _rect3, _rect4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRtf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M387 370H87V388H387V370Z",
    fill: "url(#paint0_linear_106_1062)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M275.5 278H87V296H275.5V278Z",
    fill: "url(#paint1_linear_106_1062)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M275.5 195H87V213H275.5V195Z",
    fill: "url(#paint2_linear_106_1062)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M275.5 236H87V254H275.5V236Z",
    fill: "url(#paint3_linear_106_1062)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M387 425H87V443H387V425Z",
    fill: "url(#paint4_linear_106_1062)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#0D6EFD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_1062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.8551 111V41.1818H81.0369C86.4006 41.1818 90.9006 42.1136 94.5369 43.9773C98.196 45.8409 100.957 48.4545 102.821 51.8182C104.707 55.1591 105.651 59.0568 105.651 63.5114C105.651 67.9886 104.696 71.875 102.787 75.1705C100.901 78.4432 98.1165 80.9773 94.4347 82.7727C90.7528 84.5455 86.2301 85.4318 80.8665 85.4318H62.2188V74.9318H79.1619C82.2983 74.9318 84.8665 74.5 86.8665 73.6364C88.8665 72.75 90.3438 71.4659 91.2983 69.7841C92.2756 68.0795 92.7642 65.9886 92.7642 63.5114C92.7642 61.0341 92.2756 58.9205 91.2983 57.1705C90.321 55.3977 88.8324 54.0568 86.8324 53.1477C84.8324 52.2159 82.2528 51.75 79.0938 51.75H67.5028V111H54.8551ZM90.9233 79.3636L108.207 111H94.0938L77.1165 79.3636H90.9233ZM114.224 51.7841V41.1818H169.929V51.7841H148.349V111H135.804V51.7841H114.224ZM180.668 111V41.1818H225.395V51.7841H193.315V70.7386H222.327V81.3409H193.315V111H180.668Z",
    fill: "#FAFAFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_1062",
    x: 42.8555,
    y: 41.1836,
    width: 186.539,
    height: 85.8164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_1062"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_1062",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_1062",
    x1: 237,
    y1: 195,
    x2: 237,
    y2: 443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A58CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_106_1062",
    x1: 237,
    y1: 195,
    x2: 237,
    y2: 443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A58CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_106_1062",
    x1: 237,
    y1: 195,
    x2: 237,
    y2: 443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A58CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_106_1062",
    x1: 237,
    y1: 195,
    x2: 237,
    y2: 443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A58CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_106_1062",
    x1: 237,
    y1: 195,
    x2: 237,
    y2: 443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A58CA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtf);
export default __webpack_public_path__ + "static/media/rtf.9974424a47ce27a6d9d11dd8ebbf0750.svg";
export { ForwardRef as ReactComponent };